module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_15_3-1b721348a6a0f616311af4683ca567b8.svg";